<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 133.52 76.97"
    class="unraid_sc_loader"
    :style="styles"
    :height="`${height}px`"
    role="img"
  >
    <title>{{ title }}</title>
    <desc>Unraid logo animating with a wave like effect</desc>
    <defs>
      <linearGradient
        :id="random"
        x1="23.76"
        y1="81.49"
        x2="109.76"
        y2="-4.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" :stop-color="gradientStart" />
        <stop offset="1" :stop-color="gradientStop" />
      </linearGradient>
    </defs>
    <path
      d="m70,19.24zm57,0l6.54,0l0,38.49l-6.54,0l0,-38.49z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_9"
    />
    <path
      d="m70,19.24zm47.65,11.9l-6.55,0l0,-23.79l6.55,0l0,23.79z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_8"
    />
    <path
      d="m70,19.24zm31.77,-4.54l-6.54,0l0,-14.7l6.54,0l0,14.7z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_7"
    />
    <path
      d="m70,19.24zm15.9,11.9l-6.54,0l0,-23.79l6.54,0l0,23.79z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_6"
    />
    <path
      d="m63.49,19.24l6.51,0l0,38.49l-6.51,0l0,-38.49z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_5"
    />
    <path
      d="m70,19.24zm-22.38,26.6l6.54,0l0,23.78l-6.54,0l0,-23.78z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_4"
    />
    <path
      d="m70,19.24zm-38.26,43.03l6.55,0l0,14.73l-6.55,0l0,-14.73z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_3"
    />
    <path
      d="m70,19.24zm-54.13,26.6l6.54,0l0,23.78l-6.54,0l0,-23.78z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_2"
    />
    <path
      d="m70,19.24zm-63.46,38.49l-6.54,0l0,-38.49l6.54,0l0,38.49z"
      :fill="`url(#${random})`"
      class="unraid_sc_loader_1"
    />
  </svg>
</template>

<script>
/**
 * @name Unraid Loading
 * @prop {number} height - optional, pixel value for height of loader SVG
 * @prop {object} styles
 * @prop {string} gradientStart - optional HEX color value
 * @prop {string} gradientStop - optional HEX color value
 * @prop {string} title - optional, default "Loading"
 * @example <loading :height="48" />
 */
export default {
  name: 'loading',
  props: {
    height: {
      type: Number,
      default: 64
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    gradientStart: {
      type: String,
      default: '#e32929'
    },
    gradientStop: {
      type: String,
      default: '#ff8d30'
    },
    title: {
      type: String,
      default: 'Loading'
    }
  },
  data: () => ({
    // used to create a random ID for the linear gradient
    random: Math.random()
      .toString(36)
      .substring(7)
  })
};
</script>

<style>
/*! purgecss start ignore */
.unraid_sc_loader_2,
.unraid_sc_loader_4 {
  animation: mark_2 1.5s ease infinite;
}
.unraid_sc_loader_3 {
  animation: mark_3 1.5s ease infinite;
}
.unraid_sc_loader_6,
.unraid_sc_loader_8 {
  animation: mark_6 1.5s ease infinite;
}
.unraid_sc_loader_7 {
  animation: mark_7 1.5s ease infinite;
}

@keyframes mark_2 {
  50% {
    transform: translateY(-40px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes mark_3 {
  50% {
    transform: translateY(-62px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes mark_6 {
  50% {
    transform: translateY(40px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes mark_7 {
  50% {
    transform: translateY(62px);
  }
  100% {
    transform: translateY(0);
  }
}
/*! purgecss end ignore */
</style>
